import { Grid, Typography } from '@mui/material';
import { deleteUserRoleApi, getUserByRoleIdAndInstApi, postSaveUserRoleApi } from 'api/user';
import RoleDStatusListDialog from 'app/components/Dialog/RoleDStatusListDialog';
import RoleUserList from 'app/components/List/RoleUserList';
import LoadingPopUp from 'app/components/LoadingPopup';
import { getUserFullName, swal_error } from 'app/utils/appHelpers';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import UserCustomDataTable from '../user/UserCustomDataTable';

const RoleDstatusPage = () => {

  const [loading, setLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [ykmeetingUserList, setYKMeetingUserList] = useState([]);
  const [meetingUserList, setMeetingUserList] = useState([]);
  const authUser = useSelector(state => state.auth.authUser);
  const users = useSelector(state => state.user.data);
  const [selectedUser, setSelectedUser] = useState(false);
  const [roleDialogStatus, setRoleDialogStatus] = useState(false);
  const [loadingProcess, setLoadingProcess] = useState(false);


  useEffect(() => {

    const getAPI = async () => {

      setLoading(true)

      const resultMeetingUsers = await getUserByRoleIdAndInstApi(416, "all"); // yk
      setYKMeetingUserList(resultMeetingUsers.data)

      const resultMeetingUsers2 = await getUserByRoleIdAndInstApi(417, "all"); // kurul
      setMeetingUserList(resultMeetingUsers2.data)
      const list = users.filter(user =>
        !(resultMeetingUsers.data.some(meetingUser => meetingUser.id === user.id) &&
          resultMeetingUsers2.data.some(meetingUser => meetingUser.id === user.id))
      );
      setUserList(list)

      setLoading(false)

    }
    getAPI();
  }, [])


  const handleDeleteRole = async (roleId, user) => { // unitsiz 368 ve 373 için

    Swal.fire({
      title: 'Rol Silme İşlemi',
      text: "Rolü silmek istediğinizden emin misiniz?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet Sil',
      cancelButtonText: "Vazgeç"
    }).then(async (result) => {

      if (result.isConfirmed) {
        setLoadingProcess(true)
        result = await deleteUserRoleApi({ id: user.userRoleId })

        if (result.status) {
          if (roleId === 416) {
            const filteredList = ykmeetingUserList.filter(x => x.userRoleId !== user.userRoleId);
            setYKMeetingUserList(filteredList);

            if (!userList.some(item => item.id === user.id)) {
              setUserList(prevUserList => [user, ...prevUserList]);
            }

          }

          if (roleId === 417) {
            const filteredList = meetingUserList.filter(x => x.userRoleId !== user.userRoleId);
            setMeetingUserList(filteredList);

            if (!userList.some(item => item.id === user.id)) {
              setUserList(prevUserList => [user, ...prevUserList]);
            }

          }
        }

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Silme işlemi başarılı.',
          showConfirmButton: false,
          timer: 1500
        });
        setLoadingProcess(false)
      }
    })

  }

  const roleAddCheck = (roleId, user) => {

    if (roleId === 416) {
      const isThere = ykmeetingUserList.some(x => x.id === user.id)
      return isThere
    }

    if (roleId === 417) {

      const isThere = meetingUserList.some(x => x.id === user.id)
      return isThere
    }
    return false
  }


  const handleCloseRole = async (roleId, inst, unitId = 0) => {
    if (roleId === false || !roleId || roleId === undefined || unitId === null) {

      handleDialogClose();
      return;
    }
    if (roleId !== undefined) {
      if (unitId !== 0) {
        selectedUser.customId = unitId;

      }

      Swal.fire({
        title: 'Rol Ekleme İşlemi',
        text: "Rolü eklemek istediğinizden emin misiniz?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Evet Ekle',
        cancelButtonText: "Vazgeç"
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoadingProcess(true)
          if (roleAddCheck(roleId, selectedUser)) {
            swal_error("Bu rol önceden verilmiş.")
          } else {
            const result = await postSaveUserRoleApi({ userId: selectedUser.id, roleId, inst, customId: unitId, addedUserId: authUser.id, addedDate: new Date() })
            const updatedUser = {
              ...selectedUser,
              roleInst: inst, // inst 
              userRoleId: result.userRole.id
            };


            if (result.status) {
              if (roleId === 416) {
                const updatedList = [updatedUser, ...ykmeetingUserList];
                setYKMeetingUserList(updatedList);

                if (meetingUserList.some(x => x.id === updatedUser.id)) {
                  const updatedUserList = userList.filter(user => user.id !== updatedUser.id);
                  setUserList(updatedUserList);
                }
              }
              if (roleId === 417) {
                const updatedList = [updatedUser, ...meetingUserList];
                setMeetingUserList(updatedList);

                if (ykmeetingUserList.some(x => x.id === updatedUser.id)) {
                  const updatedUserList = userList.filter(user => user.id !== updatedUser.id);
                  setUserList(updatedUserList);
                }
              }


            }

          }
          setLoadingProcess(false)
          handleDialogClose();
        } else {
          setRoleDialogStatus(false);

        }
      })
    }

  };

  const columnData = [
    { id: 'id', align: 'center', disablePadding: false, label: 'Resim' },
    { id: 'title', align: 'center', disablePadding: true, label: 'Ünvan Ad Soyad' },
    { id: 'islemler', align: 'center', disablePadding: false, label: 'İşlemler' },
  ];

  const handleDialogClose = () => {
    setRoleDialogStatus(false);
  };

  return (
    <>
      <LoadingPopUp open={loading} />
      {!loading && (
        <div>
          <Typography variant="h4" component="h1" mb={3}>Uygulanma Durumu Güncelleme Yetkisi</Typography>
          <Grid container>
            <Grid container spacing={3.75}>
              <Grid item xs={6} sm={6} lg={6}>
                <UserCustomDataTable
                  mainData={userList}
                  column={columnData}
                  pageTitle="Kullanıcı Listesi"
                  setSelectedUser={setSelectedUser}
                  setRoleDialogStatus={setRoleDialogStatus}
                />
              </Grid>
              <Grid item xs={6} sm={6} lg={6}>
                <Grid container spacing={3.75}>

                  <Grid item xs={12} sm={12} lg={12}>
                    <LoadingPopUp open={loadingProcess} />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <RoleUserList
                      key={ykmeetingUserList.length}
                      title={'YK Uygulanma Durumu Güncelleme Yetki Listesi'}
                      userList={ykmeetingUserList}
                      handleDeleteUser={(user) => handleDeleteRole(416, user)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <RoleUserList
                      key={meetingUserList.length}
                      title={'Kurul/Kol/Komisyon Uygulanma Durumu Güncelleme Yetki Listesi'}
                      userList={meetingUserList}
                      handleDeleteUser={(user) => handleDeleteRole(417, user)}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <RoleDStatusListDialog
            open={roleDialogStatus}
            onClose={() => setRoleDialogStatus(false)}
            handleCloseRole={handleCloseRole}
            pageTitle={getUserFullName(selectedUser)}
          />
        </div>
      )}
    </>
  )
}



export default RoleDstatusPage
